import { __assign } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { FieldsPreview } from "@pangeacyber/react-mui-shared";
import { PreviewSessionFields } from "./fields";
var StoreFileDetails = function (_a) {
    var object = _a.object, onClose = _a.onClose;
    var _b = useState(), archive = _b[0], setArchive = _b[1];
    var obj = useMemo(function () {
        return __assign(__assign(__assign({}, object), object === null || object === void 0 ? void 0 : object.metadata_protected), (!!(archive === null || archive === void 0 ? void 0 : archive.dest_url) && {
            dest_url: archive === null || archive === void 0 ? void 0 : archive.dest_url,
        }));
    }, [object, archive]);
    return (_jsx(_Fragment, { children: _jsx(FieldsPreview, { schema: PreviewSessionFields, data: obj, LabelPropDefaults: {
                color: "secondary",
            } }) }));
};
export default StoreFileDetails;
